/**
* @desc the ngInsuranceFluo provides support for displaying information of cancelation insurance in templates. This template is used in Purchase2
* @example <div ng-insurance-fluo insurance="insurance" passengers="passengers"></div>
*/

webClient.directive('ngInsuranceFluo', ['$window', '$timeout', '$http', 'templateService', function ($window, $timeout, $http, templateService) {
    var directive = {};
    directive.restrict = 'EA';
    directive.scope = {
        bookingdata: "=",
        insurances: "="
    };
    directive.link = function ($scope, $element) {

        templateService.compile($scope, $element, 'tpl/_InsuranceFluoTPL.html');

        //Initialize Variables
        $scope.getUrl = $window.getUrl;
        $scope.getTemplateUrl = $window.getTemplateUrl;
        $scope.siteType = $window.site.type;
        $scope.getStaticFolder = $window.getStaticFolder;
        $scope.getGlobalStaticFolder = $window.getGlobalStaticFolder;
        $scope.getTypeStaticFolder = $window.getTypeStaticFolder;
        $scope.getText = function (key) { return $window.culture.texts[key]; };
        $scope.lng = lng;

        $scope.isDisable = true;

        $scope.selectBank = function (bank) {
            $http({
                method: 'GET',
                withCredentials: false,
                headers: {
                    'mappingname': undefined,
                    'authtoken': undefined
                },
                url:
                    'https://api2.fluo.com/v1/12971ba5-3fd9-49ff-9621-266fd984bdf4/bank/' +
                    bank.id +
                    '/card?saleCountry=FR'
            }).success(function (cards) {
                $scope.cards = cards;
                $scope.bank = bank;
                $scope.card = null;
                $scope.isDisable = true;
            });
        };

        $scope.selectCard = function (e) {
            $scope.card = e;
            init($scope.bank, $scope.card);
            $scope.isDisable = false;
        };

        $http({
            method: 'GET',
            withCredentials: false,
            headers: {
                'mappingname': undefined,
                'authtoken': undefined
            },
            url:
                'https://api2.fluo.com/v1/12971ba5-3fd9-49ff-9621-266fd984bdf4/bank?saleCountry=FR',
        }).success(function (banks) {
            $scope.banks = banks;
        });

        $scope.openDiag = function (e) {

            if ($scope.isDisable === false) {
                $scope.fluoOpenModal = true;            
                angular.element(document).find('body')[0].classList.add("c-noscroll");
                if (!$scope.fluoHide) window.showWidget('FR', 'fr-FR');
                $scope.fluoHide = false;
            }

            if (e.validate) {
                if (!(typeof $scope.bank !== 'undefined' && $scope.bank != null)) {
                    FErrorShow({ oObj: document.getElementById("i-bank-select"), vErrorCode: 'data-error', vErrorCustom: "Merci de sélectionner votre type de carte" });
                    $('#i-field-error').css('z-index', '100000');
                }
                else if (!(typeof $scope.card !== 'undefined' && $scope.card != null)) {
                    FErrorShow({ oObj: document.getElementById("i-card-select"), vErrorCode: 'data-error', vErrorCustom: "Merci de sélectionner votre type de carte" });
                    $('#i-field-error').css('z-index', '100000');
                }
            }
        };

        $scope.closeDiag = function () {
            $('#i-field-error').hide();
            $scope.fluoOpenModal = false;
            $scope.fluoHide = true;
            angular.element(document).find('body')[0].classList.remove("c-noscroll");
        };

        function init(bank, card) {
            window.showWidget = function showWidget(saleCountry, language) {
                var totalPax = $scope.bookingdata.request.totalPaxes;
                var annulInsurance = $scope.insurances.find(function (x) { return x.insuranceReference === '00001'; });
                var multiInsurance = $scope.insurances.find(function (x) { return x.insuranceReference === '00002'; });
                var firstGoDate = moment($scope.bookingdata.request.itineraries[0].goDate.dateString, 'DD-MM-YYYY');
                var lastGoDate = moment($scope.bookingdata.request.itineraries[$scope.bookingdata.request.itineraries.length - 1].goDate.dateString, 'DD-MM-YYYY');
                var travelDuration = lastGoDate.diff(firstGoDate, 'days');
                fluoTravelDiag('create', {
                    partnerId: '12971ba5-3fd9-49ff-9621-266fd984bdf4',
                    mode: {
                        type: 'B2C',
                        context: 'INLINE_TRANSACTIONAL_PATH',
                        saleCountry: saleCountry,
                        language: language
                    },
                    productsSelection: [
                        {
                            id: 'MISTERFLY_MULTIRISQUES',
                            price: {
                                amount: {
                                    pax: multiInsurance.amount.int,
                                    total: multiInsurance.amount.int * totalPax
                                },
                                currency: 'EUR'
                            }
                        },
                        {
                            id: 'MISTERFLY_ANNULATION',
                            price: {
                                amount: {
                                    pax: annulInsurance.amount.int,
                                    total: annulInsurance.amount.int * totalPax
                                },
                                currency: 'EUR'
                            }
                        }
                    ],
                    travel: {
                        durationInDays: travelDuration,
                        destination: $scope.bookingdata.request.itineraries[$scope.bookingdata.request.itineraries.length - 1].origin.countryISO,
                        cost: {
                            amount: $scope.bookingdata.request.totalAmount.int,
                            currency: 'EUR'
                        }
                    },
                    onAccept: function (productId) {
                        $scope.fluoOpenModal = false;
                        $scope.fluoHide = true;
                        productId === "MISTERFLY_ANNULATION" ? productId = "00001" : productId = "00002";
                        var selectedInsurance = $scope.insurances.find(function (x) { return x.insuranceReference === productId; });
                        
                        $scope.$emit("onInsuranceClick", { 
                            type: productId, 
                            amount: selectedInsurance.total.int, 
                            company: selectedInsurance.companyReference, 
                            quantity: totalPax, 
                            comparisonDisplayed: true 
                        });

                        $scope.$emit("fluoSelectedInsurance", true, productId);
                        $scope.fluoAccept = true;
                        $scope.selectedInsurance = productId;
                        angular.element(document).find('body')[0].classList.remove("c-noscroll");
                    },
                    onReject: function (comparisonDisplayed) {
                        $scope.fluoOpenModal = false;
                        $scope.fluoHide = true;
                        $scope.$apply();
                        angular.element(document).find('body')[0].classList.remove("c-noscroll");
                    },
                    onShowDiagnosis: function () {
                        $(".button-deny a").html("non, laissez moi tranquille");
                        $scope.fluoOpenModal = true;
                        angular.element(document).find('body')[0].classList.add("c-noscroll");
                        $scope.$emit("fluoDisplayed");                        
                    },
                    theme: {
                        triggerClass: 'fluo-widget',
                        coverageTitle: 'd-none',
                        coverageTitleIcon: 'warning-icon',
                        bankAndCardSelectionContainer: 'd-none',
                        //comparisonTable: 'c-upsel',
                        comparisonCellLabel: 'c-title',
                        criterionLabel: 'c-baseline',
                        criterionValueLabel: 'value-label',
                        buttonAccept: 'c-btn-l flex-column c-align-c confirm-button',
                        //buttonDeny: 'd-none',
                        productSelectorContainer: 'insurance-selector-container',
                        productSelectorButtonSelected: 'insurance-selector-button-selected',
                        productSelectorButton: 'insurance-selector-button',
                        unitPrice: 'unit-price',
                        unitLabel: 'unit-label'
                    },
                    bank: bank,
                    card: card
                });
            };
        }
    };
    return directive;
}]);
